/** ***************************
 * environment.js
 ***************************** */
const NIKU_CLIENT_APP_ID = "c018c7e7-7b4d-4951-ac8c-aaf129bfce2a";
const CLIENT_API_KEY = "Basic ZGZiYTlkZTMtNWYxNi00MTViLThiYmItYWY4NDgyMjQ1NTBi";

const NIKU_SELLER_APP_ID = "089ac01f-bea0-49fa-9fd6-6fa5840b60d2";
const SELLER_API_KEY = "Basic NDQyYmJjN2ItMjA5Zi00NmMzLTg0ZDQtMGZiYjAzYTkyMDQx";

const NIKU_DELIVERY_APP_ID = "8862c476-3d4f-4e26-ae65-ea64d5770ea0";
const DELIVERY_API_KEY = "Basic ZWIxNDQ3ZGUtNTZlOS00NjVkLTk2NDItNGMyNmQ0MDdkZmUy";

const NEW_MESSAGE_CHANNEL_SELLER = "6a0bc502-e4fb-471a-af6b-70e052da4145";
const NEW_ORDER_CHANNEL_SELLER = "7955f815-ef64-4c6a-b199-6824025d43d1";

const NEW_MESSAGE_CHANNEL_DELIVERY = "a2ddcbbf-df07-427b-9da3-a52985805344";
const NEW_ORDER_CHANNEL_DELIVERY = "377d2c5f-127d-4266-a73b-98e614420d81";

const NEW_MESSAGE_CHANNEL_CLIENT = "dbd6b0b6-0f5c-492b-9b7f-24152edd9e1a";
const NEW_ORDER_CHANNEL_CLIENT = "f668f21f-7219-4f4a-b1e4-14247829d7dc";

const USER_ID_DEMO = "c0e33050-9f08-49ce-8ebc-dbd5f3789228";
const URL_BACKEND_API = "http://3.138.84.242:4004/api/v1";
const URL_GEOCODE = "https://maps.googleapis.com/maps/api/geocode/json?";

const ENV = {
  prod: {
    googleApiKey: "AIzaSyBL9WpmsTlsd5PdPJO9SLZWVOuRGBaitBg",
    indexNameHere: "NikuPlaceIndex",
    URL_BACKEND_API,
    USER_ID_DEMO,
    URL_GEOCODE,
    NIKU_CLIENT_APP_ID,
    CLIENT_API_KEY,
    NIKU_SELLER_APP_ID,
    SELLER_API_KEY,
    NIKU_DELIVERY_APP_ID,
    DELIVERY_API_KEY,
    NEW_MESSAGE_CHANNEL_SELLER,
    NEW_ORDER_CHANNEL_SELLER,
    NEW_MESSAGE_CHANNEL_DELIVERY,
    NEW_ORDER_CHANNEL_DELIVERY,
    NEW_MESSAGE_CHANNEL_CLIENT,
    NEW_ORDER_CHANNEL_CLIENT
  },
};

const getEnvVars = () => {
    return ENV.prod;
};

export default getEnvVars;
